import React from "react";

export default function About({ t }) {
  return (
    <section id="about" data-testid="about-section" className="relative bg-ink border-t border-line py-24 md:py-36 overflow-hidden">
      <div className="px-6 md:px-12 lg:px-20 grid md:grid-cols-12 gap-10 md:gap-16">
        <div className="md:col-span-5 relative">
          <div className="relative overflow-hidden img-hover-wrap aspect-[3/4]">
            <img
              src="/img/about-portrait.webp"
              alt="Alexis Lecoeuvre — Nono"
              className="absolute inset-0 w-full h-full object-cover object-top img-hover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-ink/10 to-ink/30" />
          </div>
          <p translate="no" className="notranslate hidden md:block absolute -bottom-6 -right-2 font-display text-[10vw] leading-none uppercase tracking-tighter text-bone/[0.06] select-none pointer-events-none">
            NONO
          </p>
        </div>

        <div className="md:col-span-6 md:col-start-7">
          <div className="flex items-center gap-4 mb-6">
            <span className="block h-px w-10 bg-leaf"></span>
            <p className="text-[11px] tracking-[0.4em] uppercase text-ash">{t.about.eyebrow}</p>
          </div>
          <h2
            data-testid="about-title"
            className="font-serif font-light text-bone text-4xl sm:text-5xl md:text-6xl leading-[1.02] tracking-tight"
          >
            {t.about.title}
            <br />
            <span className="italic">{t.about.title2}</span>
          </h2>

          <div className="mt-10 space-y-6 max-w-xl">
            <p className="text-bone/90 text-base md:text-lg leading-relaxed">{t.about.p1}</p>
            <p className="text-ash text-base leading-relaxed">{t.about.p2}</p>
            <p className="font-serif italic text-bone text-xl md:text-2xl pt-4 border-l border-leaf pl-6">
              {t.about.p3}
            </p>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-8 max-w-md border-t border-line pt-8">
            <div>
              <p className="font-display text-3xl text-bone">100+</p>
              <p className="text-[10px] tracking-[0.32em] uppercase text-ash mt-2">Fight nights</p>
            </div>
            <div>
              <p className="font-display text-3xl text-bone">50+</p>
              <p className="text-[10px] tracking-[0.32em] uppercase text-ash mt-2">Fighters</p>
            </div>
            <div>
              <p className="font-display text-3xl text-bone">EU</p>
              <p className="text-[10px] tracking-[0.32em] uppercase text-ash mt-2">Based</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
